import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBorderHorizontalComponent } from "./med-icon-border-horizontal.component";

@NgModule({
  declarations: [
    MedIconBorderHorizontalComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBorderHorizontalComponent,
  ],
})
export class MedIconBorderHorizontalModule { }
